<template>
  <div id="main" style="width: 100%;height:100%;position: absolute;"></div>
</template>
<script src="./js/echarts.js"></script>
<script src="./js/jquery.min.js"></script>
<script>
  import * as echarts from 'echarts';
  export default {
    name: 'Map',
    data () {
      return {
        baseUrl: 'http://goc6.com',
        fromTime: new Date(new Date().toLocaleDateString()).getTime(),
        score : 100,
        workList : []
      }
    },
    mounted () {
      this.init();
      var retur = document.getElementById('return');
      // let that= this;
      // retur.on('click', function (params) {
      //   that.proces("100000")
      // });
    },
    methods: {
        init(){
          var chartDom = document.getElementById('main');
          // chartDom.innerHTML='';
          var chart = echarts.init(chartDom);
          let that = this;
          this.$axios.get('https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json', {
          }).then(function (response) {
            console.log(response.data);
            echarts.registerMap('河北省', response.data);
            let option = {
              title: {
                text: '去过的地方',
                x:'center'
              },
              dataRange:{
                min:0,
                max:500,
                text:['高','低'],
                realtime:true,
                calculable:true,
                color:['orangered','yellow','green']
              },
              series:[
                {
                  name:'去过的地方',
                  type:'map',
                  map:'河北省',
                  mapLocation:{
                    y:60
                  },
                  itemSytle:{
                    emphasis:{label:{show:false}}
                  },
                  data:[
                    {name:'北京市',value:110000},
                    {name:'河北省',value:130000},
                    {name:'海南省',value:460000},
                    {name:'山东省',value:370000},
                    {name:'福建省',value:350000}
                  ]
                }
              ],

            };
            chart.setOption(option);
            chart.on('click', function (params) {
              console.log(params)
              try{
                chart.setOption(option);
                that.proces(params.data.value)
              }catch (e){
                that.proces('100000')
              }
            });
          })
      },
      proces(num){
        var chartDom = document.getElementById('main');
        // chartDom.innerHTML='';
        var chart = echarts.init(chartDom);
        let that = this;
        this.$axios.get('https://geo.datav.aliyun.com/areas_v3/bound/'+num+'_full.json', {
        }).then(function (response) {
          console.log(response.data);
          echarts.registerMap('河北省', response.data);
          let option = {
            title: {
              text: '去过的地方',
              x:'center'
            },
            dataRange:{
              min:0,
              max:500,
              text:['高','低'],
              realtime:true,
              calculable:true,
              color:['orangered','yellow','green']
            },
            series:[
              {
                name:'去过的地方',
                type:'map',
                map:'河北省',
                mapLocation:{
                  y:60
                },
                itemSytle:{
                  emphasis:{label:{show:false}}
                },
                data:[
                  {name:'石家庄市',value:700},
                  {name:'保定市',value:600},
                  {name:'廊坊市',value:500},
                  {name:'张家口市',value:400},
                  {name:'邢台市',value:400},
                  {name:'秦皇岛市',value:100}
                ]
              }
            ],

          };
          if(num=='100000'){
            option.series[0].data = [
              {name:'北京市',value:110000},
              {name:'河北省',value:130000},
              {name:'海南省',value:460000},
              {name:'山东省',value:370000},
              {name:'福建省',value:350000}
            ];
          }else if(num==130000){
            option.series[0].data = [
              {name:'石家庄市',value:700},
              {name:'保定市',value:600},
              {name:'廊坊市',value:500},
              {name:'张家口市',value:400},
              {name:'邢台市',value:400},
              {name:'秦皇岛市',value:100}
            ];
          }else if(num==110000){
            option.series[0].data = [
              {name:'昌平区',value:700},
              {name:'海淀区',value:600},
              {name:'朝阳区',value:500},
              {name:'延庆区',value:700},
              {name:'顺义区',value:700},
              {name:'西城区',value:700},
              {name:'东城区',value:700},
              {name:'丰台区',value:700},
              {name:'大兴区',value:700}
            ];
          }else if(num==460000){
            option.series[0].data = [
              {name:'三亚市',value:700}
            ];
          }else if(num==370000){
            option.series[0].data = [
              {name:'泰安市',value:700}
            ];
          }else if(num==350000){
            option.series[0].data = [
              {name:'厦门市',value:700}
            ];
          }


          /*
          [
                    {name:'北京市',value:110000},
                    {name:'河北省',value:130000},
                    {name:'海南省',value:460000},
                    {name:'山东省',value:370000},
                    {name:'福建省',value:350000}
                  ]
           */
          chart.setOption(option);
          chart.on('click', function (params) {
            that.proces('100000')
          });
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  body {
    margin: 0;
    background-color: #eaeaea;
    display: grid;
    height: 100vh;
    place-items: center;
    font-family: 'Source Sans Pro', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/game/Map.vue